import { ArrowDown } from 'lucide-react';
import Avatar3 from '../../images/avatar3.jpg';
import ParachuteJump from '../../images/skok_ze_spadochronem.jpg';

export default function Tata() {
	return (
		<div className="flex flex-col gap-3">
			<p className="text-3xl text-center font-medium text-customBlue mb-3">
				A miało być tak fajnie...
			</p>
			<img
				src={ParachuteJump}
				alt="parachute"
				className="mx-auto rounded-lg shadow-lg shadow-gray-400/50 w-[40%] object-cover h-[400px]"
			/>

			<ArrowDown size={100} className="text-customBlue my-20 mx-auto" />

			<p className="text-2xl text-center font-medium mb-4">
				Ale skoro nie chcesz jeszcze zejść na zawał, to może to będzie bardziej
				odpowiednia forma rozrywki
			</p>

			<img
				src={Avatar3}
				alt="avatar3"
				className="mx-auto mb-8 rounded-lg shadow-lg shadow-gray-400/50 w-[40%] object-cover"
			/>
			<i className="text-2xl text-orange-600 text-center font-bold mb-4">
				Do zrealizowania w pierwszej połowie stycznia
			</i>
		</div>
	);
}
